import { AssessmentCard, Card } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Separator, Text, View, XStack } from "tamagui";

import { api } from "~/utils/api";
import { resolveFilter, useGeneralFilter } from "~/components/blocks/filters";

export const ImminentRisk = () => {
  const { t } = useTranslation("metrics");
  const { filter } = useGeneralFilter();
  const { groupBy: _, ...rest } = filter;

  const [data] = api.dashboard.getDangerCards.useSuspenseQuery({
    filter: resolveFilter(rest),
  });

  return (
    <Card
      data-id="imminent-risk-card"
      padding={0}
      gap={"$5"}
      variant="borderless"
    >
      <View
        data-id="imminent-risk-container"
        paddingTop={"$2"}
        width={"100%"}
        alignItems="center"
        justifyContent="center"
        gap={"$2"}
      >
        <Card.Title fontSize={"$7"} data-id="imminent-risk-title">
          {t("hmt-dashboard.imminent-risk.title")}
        </Card.Title>
        <Text
          data-id="imminent-risk-description"
          fontFamily={"$subtitle"}
          fontWeight={"$5"}
          fontSize={"$4"}
          lineHeight={"$4"}
          textAlign={"center"}
          color={"$gray-950"}
        >
          {t("hmt-dashboard.imminent-risk.subtitle")}
        </Text>
      </View>

      <XStack gap={"$2"} flex={2} data-id="imminent-risk-wrapper">
        {data?.map(({ count, percentage, desc }, i) => (
          <AssessmentCard.Body
            data-id={`imminent-risk-body-${i}`}
            width={"50%"}
            key={i}
            flex={1}
            paddingHorizontal={"$2.5"}
            paddingVertical={"$3"}
            shadow="md"
            gap={"$2"}
          >
            <View
              flexDirection="row"
              maxHeight={"$3.5"}
              gap={"$2"}
              alignItems="center"
            >
              <AssessmentCard.ScoreContainer
                data-id={"imminent-risk-score-container-" + i}
              >
                <AssessmentCard.Score
                  state="success"
                  data-id={"imminent-risk-score-" + i}
                >
                  {count}
                </AssessmentCard.Score>
              </AssessmentCard.ScoreContainer>
              {!isNaN(Number(percentage)) && (
                <>
                  <AssessmentCard.Separator height={"$2"} />
                  <AssessmentCard.Score
                    font="md"
                    data-id={"imminent-risk-score-" + i}
                    state="success"
                  >
                    {`(${percentage}%)`}
                  </AssessmentCard.Score>
                </>
              )}
            </View>
            {!isNaN(Number(percentage)) ? (
              <AssessmentCard.Progress
                data-id={"imminent-risk-progress-" + i}
                variant="success"
                size="lg"
                rounded="lg"
                value={Number(percentage)}
              />
            ) : (
              <Separator
                width={"100%"}
                borderBottomColor={"$gray-primary-900"}
                borderBottomWidth={"$0.2"}
              />
            )}

            <AssessmentCard.Description
              data-id={"imminent-risk-description-" + i}
            >
              {desc}
            </AssessmentCard.Description>
          </AssessmentCard.Body>
        ))}
      </XStack>
    </Card>
  );
};
